import { HttpClient, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, catchError, lastValueFrom, map, Observable, of } from "rxjs";
import { LocalStorageKey } from "../_helper/local-storage.helper";
import { parseJwt } from "../_helper/utils";
import { ProcessLoadingService } from "./loading.service";
import { environment } from "../../environments/environment";
import { API_ENDPOINTS } from "../constants/api-endpoints";
import { ROUTE_PATH } from "../constants/route-path";
import { ApiService } from "./api.service";
import { MapInfo } from "../models/mapinfo.model";
import { MapInfoRO } from "../models/response/mapinfo/mapinfo.ro.model";
import { MapInfoDTO } from "../models/request/mapinfo/mapoinfo.dto.model";
import { AuthenticationService } from "./authentication.service";
import { SessionStorageKey } from "../constants/session-storage-key";
import { OrgInfo } from "../models/orginfo.model";
import { FloorInfo } from "../models/floorinfo.model";
import { BaseInfo } from "../models/baseinfo.model";

@Injectable({ providedIn: 'root' })
export class MapService extends ApiService {

  private lstMapManagerSubject: BehaviorSubject<MapInfo[] | null>;
  public lstMapManager: Observable<MapInfo[] | null>;



  constructor(
    http: HttpClient,
    router: Router,
    private authenticationService: AuthenticationService
  ) {
    super(http, router);
    this.lstMapManagerSubject = new BehaviorSubject<MapInfo[] | null>(JSON.parse(sessionStorage.getItem(SessionStorageKey.LIST_MAP_MANAGER) || '[]'));
    this.lstMapManager = this.lstMapManagerSubject.asObservable();
 
    this.authenticationService!.officeSelected.subscribe(office => {
      if(!this.authenticationService.isLoggedIn) {
        this.lstMapManagerSubject.next(null);
      }
    });
  }
  setLstMapManagerValue(lstMapManager: MapInfo[] | null) {
    sessionStorage.setItem(SessionStorageKey.LIST_MAP_MANAGER, JSON.stringify(lstMapManager));
    this.lstMapManagerSubject.next(lstMapManager);
  }
  getLstMapManagerValue(): MapInfo[] | null {
    return this.lstMapManagerSubject.value;
  }

  async getMapList(mapids: string[]): Promise<MapInfo[] | null> {
    let url = API_ENDPOINTS.MAP_INFO.CONTROLLER + API_ENDPOINTS.MAP_INFO.LIST_MAP;

    let payload: MapInfoDTO = {
      listmapid: mapids
    };

    let resData = await lastValueFrom(this.post<MapInfoRO, MapInfoDTO>(url, payload));

    if (resData && resData.status === HttpStatusCode.Ok && resData.result) {
      return resData.result.listmapinfo || null;
    }
    return null;
    
  }


  async getMapDetailpublic(mapid:string): Promise<MapInfo | null> {
    let pra: any = {
       mid: mapid
    }

    let url = API_ENDPOINTS.EDGE.CONTROLLER + API_ENDPOINTS.EDGE.DETAIL_PUBLIC;
  
      let resData = await lastValueFrom(this.post(url, pra));

      if (resData && resData.status === HttpStatusCode.Ok) {
        return resData.result.mapinfo || null;
      }
    return null
  }

  async getMapDetail(mapid:string, floors: FloorInfo[] = []): Promise<MapInfo | null> {
    let pra: any = {
       mid: mapid
    }

    let url = API_ENDPOINTS.MAP_INFO.CONTROLLER + API_ENDPOINTS.MAP_INFO.DETAIL;
  
      let resData = await lastValueFrom(this.post(url, pra));

      if (resData && resData.status === HttpStatusCode.Ok) {
        if(resData.result.mapinfo.bases && resData.result.mapinfo.bases.length > 0) {
          resData.result.mapinfo.bases.forEach((base: BaseInfo) => {
            let floor = floors.find((f: FloorInfo) => f.floorid === base.floorid);
            if(floor) {
              base.pX = (floor.xOffset ?? 0) + (base.pX ?? 0);
              base.pY = (floor.yOffset ?? 0) + (base.pY ?? 0);
            }
          })
        };
        return resData.result.mapinfo || null;
      }
    return null
  }
  
  async getCompanyIDByMapID(mapid:string): Promise<OrgInfo[] | null> {
    let pra: any = {
       mid: mapid
    }

    let url = API_ENDPOINTS.MAP_INFO.CONTROLLER + API_ENDPOINTS.MAP_INFO.GET_COMPANY_BY_MAPID;
  
      let resData = await lastValueFrom(this.post<MapInfoRO, MapInfoDTO>(url, pra));

      if (resData && resData.status === HttpStatusCode.Ok && resData.result && resData.result.lstorginfo) {
        return resData.result.lstorginfo;
      }
    return null
  }

  syncMapMasterData(): Observable<any> {
    let payload: any = {
      // orgid : ORG_ID,
      // compid: COMP_ID,
      // mid: MAP_ID
    }
    const url = API_ENDPOINTS.SYNCDATA.CONTROLLER + API_ENDPOINTS.SYNCDATA.SYNC_MAP;
    return this.http.post(url, payload).pipe(
      catchError(err => of(err)),
      map((response: any) => {
        if (response === 1) {
          return true;
        }
        return false;
      }));
  }

  async getMapListByCompany(): Promise<MapInfo[] | null> {
    let url = API_ENDPOINTS.MAP_INFO.CONTROLLER + API_ENDPOINTS.MAP_INFO.LIST_MAP_BY_COMPANY;
    try {
      let resData = await lastValueFrom(this.get<MapInfoRO>(url));
      if (resData && resData.status === HttpStatusCode.Ok && resData.result) {
        return resData.result.listmapinfo || null;
      }
    } catch (e) { }
    return null
  }
}
